
import type { SetupContext } from 'vue'
import { computed, defineComponent, inject, ref, watch } from 'vue'
import { useElementSize } from '../../../composables/use-element-size'
import { GET_PROPS_KEYS, UPDATE_CONFIG_KEYS } from './consts'

export interface EpbVirtualScrollerListResizeEvent {
  width: number
  heigth: number
}

export default defineComponent({
  name: 'EpbVirtualScrollerList',
  emits: {
    resize: (event: EpbVirtualScrollerListResizeEvent): void => {},
  },
  setup(props, ctx: SetupContext) {
    const updateParentConfig = inject<() => void>(UPDATE_CONFIG_KEYS)
    const getParentProps = inject<() => { itemsPerRow: number }>(GET_PROPS_KEYS)

    const listRef = ref<HTMLUListElement>(null)

    const itemsPerRow = computed(() => {
      const { itemsPerRow } = getParentProps()
      return itemsPerRow
    })

    const { width, heigth } = useElementSize(listRef)

    watch([width, heigth], () => {
      updateParentConfig()

      ctx.emit('resize', { width: width.value, heigth: heigth.value })
    })

    return {
      baseClass: 'epb-virtual-scroller-list',
      listRef,
      itemsPerRow,
    }
  },
})
